export const GET_INVITERS = "GET_INVITERS";
export const GET_ALL_INVITERS = "GET_ALL_INVITERS";